export default {
    ConnectEsign: {
        Title: 'Thiết lập chữ ký số',
        ButtonTitle: 'Kết nối ngay',
        ConnectedButtonTitle: 'Đã kết nối',
        Attention: 'Khi ký số bằng USB Token của bất kỳ nhà cung cấp nào (MISA, VNPT, Viettel, Cyber Lotus,...), bạn cần lưu ý:',
        AttentionFirstLine: (link) => 'Cài đặt công cụ hỗ trợ ký số của MISA là <b>MISA KYSO</b>. Nếu chưa cài đặt MISA KYSO, vui lòng tải bộ cài <a href="' + link + '" target="_blank" class="text-link">tại đây</a>.',
        AttentionSecondLine: 'Đảm bảo đã cắm USB token vào máy tính mỗi khi thực hiện ký điện tử.',
    },
    ContactAdditionalList: {
        Title: 'Email nhận thông báo từ Cơ quan thuế',
        DeleteContactAdditionalConfirmMessage: 'Email bị xóa sẽ không thể khôi phục lại. Bạn có chắc muốn xóa email này?',
        DeleteSuccessfully: 'Xóa email nhận thông báo từ cơ quan thuế thành công.'
    },
    Resources: {
        Title: 'Tài nguyên',
        CancelOrderTitle: 'Hủy đơn hàng',
        AcceptPayTitle: 'Xác nhận thanh toán',
        OrderDetail: 'Chi tiết đơn hàng',
        HelpPaymentTitle: 'Hướng dẫn thanh toán',
        ActiveStoreTitle: 'Nhập mã kích hoạt',
    },
    ContactAdditionalDetail: {
        Title: 'email nhận thông báo từ Cơ quan thuế',
        AddSuccessfully: 'Thêm email nhận thông báo từ cơ quan thuế thành công.',
        UpdateSuccessfully: 'Cập nhật email nhận thông báo từ cơ quan thuế thành công.'
    },
    AccessLog: {
        QuickSearchPlaceHolderContent: 'Tìm kiếm theo hành động, mô tả, người dùng, địa chỉ IP',
    },
    OptionsSettings: {
        SubTitle1: 'Nhận email thông báo',
        SubTitle2: 'Thiết lập cảnh báo'
    }
}